<template>
  <div class="boards-list-item" :class="`${boardModeModifierClass(mode)} ${indexIsOdd ? 'boards-list-item--odd' : 'boards-list-item--even'}`">
    <div class="boards-list-item__left">
      <h3 v-if="orderBy === orderByConstants.NAME.CONSTANT" class="board-id-and-name">
        <router-link
          :to="{
            name: 'view-board',
            params: {boardId: boardId},
          }"
          class="board-name"
          >{{ name }}</router-link
        >
        <span class="board-id">:&nbsp;{{ boardId }}</span>
      </h3>
      <h3 v-else class="board-id-and-name">
        <span class="board-id">{{ boardId }}:</span>&nbsp;
        <router-link
          :to="{
            name: 'view-board',
            params: {boardId: boardId},
          }"
          class="board-name"
          >{{ name }}</router-link
        >
      </h3>
      <h4 v-if="orderBy === orderByConstants.LAYOUT.CONSTANT" class="layout">{{ layoutLabel }}</h4>
      <h4 v-else-if="orderBy === orderByConstants.CREATION_DATE.CONSTANT" class="creation-date">
        {{ creationDateFormatted }} <span class="time-ago">({{ createdAtTimeAgo }})</span>
      </h4>
      <h4 v-else class="category">{{ categories[category].DISPLAY_NAME }}</h4>
    </div>
    <div class="boards-list-item__right">
      <router-link
        :to="{
          name: 'play',
          params: {boardIdOrSlug: slug},
        }"
        title="Play"
        ><span class="sr-only">Play</span
        ><span class="material-icons" aria-hidden="true">
          play_arrow
        </span></router-link
      >
      <router-link
        v-if="boardId"
        :to="{
          name: 'view-board',
          params: {boardId: boardId},
        }"
        title="View"
        ><span class="sr-only">View</span
        ><span class="material-icons" aria-hidden="true">
          visibility
        </span></router-link
      >
      <router-link
        v-if="boardId"
        :to="{
          name: 'edit-board',
          params: {boardId: boardId},
        }"
        title="Edit"
        ><span class="sr-only">Edit</span
        ><span class="material-icons" aria-hidden="true">
          edit
        </span></router-link
      >
      <button type="button" @click="onTogglePromote" class="toggle-promote-btn" :title="promoteText" :class="`toggle-promote-btn--${promoted ? 'promoted' : 'not-promoted'}`">
        <span class="sr-only">{{ promoteText }}</span
        ><span class="material-icons" aria-hidden="true">
          {{ promoted ? 'arrow_circle_down' : 'arrow_circle_up' }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find';
import db from './../firebaseInit';
import {BOARD_MODES, CATEGORIES, ORDER_BY, NOTIFICATION_SETTINGS, BOARD_PORTRAIT_LAYOUTS_SELECT_DATA} from './../constants/globalConstants';
import isOdd from './../helpers/isOdd';
import formatDateFromFirebaseTimestamp from './../helpers/formatDateFromFirebaseTimestamp';
import timeAgoFromFirebaseTimestamp from './../helpers/timeAgoFromFirebaseTimestamp';

export default {
  name: 'ListBoardsItem',
  components: {},
  props: {
    boardId: String,
    boardPortraitLayout: String,
    category: String,
    createdAt: Object,
    index: Number,
    mode: String,
    name: String,
    orderBy: String,
    promoted: Boolean,
    slug: String,
  },
  data() {
    return {};
  },
  computed: {
    indexIsOdd: function() {
      return isOdd(this.index);
    },
    promoteText: function() {
      return this.promoted ? 'Remove promotion' : 'Promote this board';
    },
    orderByConstants: function() {
      return ORDER_BY;
    },
    categories: function() {
      return CATEGORIES;
    },
    layouts: function() {
      return BOARD_PORTRAIT_LAYOUTS_SELECT_DATA;
    },
    layoutLabel: function() {
      return find(this.layouts, {value: this.boardPortraitLayout}).label;
    },
    creationDateFormatted: function() {
      return formatDateFromFirebaseTimestamp(this.createdAt);
    },
    createdAtTimeAgo: function() {
      return timeAgoFromFirebaseTimestamp(this.createdAt);
    },
  },
  methods: {
    boardModeModifierClass: function(boardMode) {
      switch (boardMode) {
        case BOARD_MODES.LIVE.CONSTANT:
          return `boards-list-item--${BOARD_MODES.LIVE.CSS_MODIFIER}`;
        case BOARD_MODES.TESTING.CONSTANT:
          return `boards-list-item--${BOARD_MODES.TESTING.CSS_MODIFIER}`;
        case BOARD_MODES.DISABLED.CONSTANT:
          return `boards-list-item--${BOARD_MODES.DISABLED.CSS_MODIFIER}`;
        default:
          return '';
      }
    },
    onTogglePromote: function() {
      console.log('onTogglePromote()');
      this.$store.dispatch('boardsVuexModule/TOGGLE_PROMOTE_BOARD_ACTION', {boardId: this.boardId});
    },
    // onTogglePromote: function() {
    //   this.$emit('toggle-promoted', {boardId: this.boardId, promoted: !this.promoted});

    //   db.collection('boards')
    //     .where('boardId', '==', this.boardId)
    //     .get()
    //     .then(snapshot => {
    //       snapshot.forEach(doc => {
    //         doc.ref
    //           .update({
    //             promoted: !doc.data().promoted,
    //           })
    //           .then(() => {})
    //           .catch(err => {
    //             this.$snotify.error('Error toggling promoted', '', NOTIFICATION_SETTINGS);
    //           });
    //       });
    //     });
    // },
  },
};
</script>

<style lang="scss" scoped>
.boards-list-item {
  border-bottom: 1px solid var(--color-subtle-border);
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;

  @include breakpoint($mq-lg) {
    flex-direction: row;
  }

  &:last-child {
    border-bottom: 0;
  }

  &--odd {
    background-color: var(--color-list-board-odd-background);
  }

  &__left {
    margin: 0 0 1rem 0;

    @include breakpoint($mq-lg) {
      margin-bottom: 0;
      width: 100%;
    }
  }

  &__right {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    a {
      display: block;
      margin-right: 1rem;
      text-decoration: none;
      &:last-child {
        margin-right: 0;
      }

      .material-icons {
        display: block;
        font-size: 4rem;
      }
    }
  }

  &--live {
    border-left: 3px solid green;
  }
  &--testing {
    border-left: 3px solid orange;
  }
  &--disabled {
    border-left: 3px solid red;
  }
}

.board-id-and-name {
  margin: 0 0 1rem 0;
}

.board-id {
  font-weight: 300;
}

.board-name {
  text-decoration: none;
}

.category,
.layout,
.creation-date {
  margin: 0;
  padding: 0;
  font-weight: 300;
  font-size: 1.2rem;
  color: var(--text-color-alpha-50);
}

.toggle-promote-btn {
  background-color: transparent;
  border-radius: 0;
  line-height: 0;
  margin: 0;
  padding: 0;

  &--promoted {
    color: var(--text-color);
  }

  &--not-promoted {
    color: var(--text-color-alpha-10);
  }

  .material-icons {
    font-size: 4rem;
  }
}

.time-ago {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 300;
  opacity: 0.4;
}
</style>
